import { TileGridRenderState, TileRenderState } from "../common";
import { GridItem, GridState } from "client_legacy/Workspace/gridState";
import * as tileSelectors from "./tile";

export function generateStateOfTilesConsumingSpace(
	tileGrid: Pick<TileGridRenderState, "tiles" | "settings">,
	doNotApplyPackingAlgorithm: boolean = false
): GridState<TileRenderState> {
	const {
		tiles,
		settings
	} = tileGrid;

	const gridItems: GridItem<TileRenderState>[] = [];

	for (const tileRenderState of tiles) {
		if (tileRenderState.isBeingDragged) {
			continue;
		}

		if (!tileRenderState.isVisible) {
			continue;
		}

		const {
			data: { position },
			dimension: { dimension }
		} = tileRenderState;

		gridItems.push({
			position: { ...position },
			dimension: { ...dimension },
			item: tileRenderState
		});
	}

	const state = new GridState<TileRenderState>(gridItems);

	return doNotApplyPackingAlgorithm
		? state
		: state.apply(settings.packingAlgorithm);
}

export function isNotEmptyAndAllTilesAreHiddenByConditionalAccess(currentState: Pick<TileGridRenderState, "tiles">): boolean {
	const {
		tiles
	} = currentState;

	return tiles.length > 0
		&& tiles.every(t => tileSelectors.isHiddenByConditionalAccess(t));
}